module.exports = "<!-- Main view/routes wrapper-->\r\n<toaster-container [toasterconfig]=\"toasterconfig\"></toaster-container>\r\n<router-outlet></router-outlet>\r\n<psm-modal-container></psm-modal-container>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main